import React, { useState, useRef } from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import {toast} from "react-toastify";
import {QUOTE_PAGES} from "../pages/JobQuotePage";
import ArchiveJobQuoteModal from "../modals/ArchiveJobQuoteModal";
import PdfDownloadButton from "../components/PdfDownloadButton";

const JobQuoteDataTable = (props) => {
    const {
        jobId,
        parentId,
        onChangePage = (CREATE, quote) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [archiveJobQuoteModal, setArchiveJobQuoteModal] = useState(null);

    const renderRowButton = (quote) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!quote.can && (quote.can.view === true || can('create', 'order') || quote.can.update === true || quote.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!quote.can.view === true && (
                                    <PdfDownloadButton
                                        label="Download Quote"
                                        href={route('job.quote.export', {
                                            job:     jobId,
                                            quote:   quote.id,
                                        }).toString()}
                                    />
                                )}
                                {!!quote.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(QUOTE_PAGES.EDIT, quote)}
                                    >
                                        <span>Edit Quote</span>
                                    </button>
                                )}
                                {can('create', 'order') === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(QUOTE_PAGES.CONVERT, quote)}
                                    >
                                        <span>Convert To Order</span>
                                    </button>
                                )}
                                {!!quote.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveJobQuoteModal(quote)}
                                    >
                                        <span>Delete Quote</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Quotes"}
                classes={"mh-100 border-0"}
                controls={can('create', 'product') ? (
                    <button onClick={(event) => {
                        event.preventDefault();
                        onChangePage(QUOTE_PAGES.CREATE, null);
                    }} className={"btn font-weight-bold btn-eh-lilac px-4 m-0"}>
                        <i className={"far fa-plus-circle mr-2"} />
                        <span>{"Create Quote"}</span>
                    </button>
                ) : null}
            >
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.quote.data-table', {job: jobId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="quotes" />}
                                fieldsToExclude={[
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    "id",
                                    "name",
                                    "products_count",
                                    "status",
                                    "products_sum_price",
                                    "created_at",
                                    "created_by",
                                ]}
                                fieldMap={{
                                    id:                 "Quote Reference",
                                    name:               "Quote Name",
                                    products_count:     "Products",
                                    products_sum_price: "Price",
                                    created_at:       "Quote Created",
                                    created_by:         "Created By",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            if (value === "Discarded") {
                                                return (
                                                    <span className={"text-danger font-weight-bold"}>{value}</span>
                                                );
                                            } else if (value === "Converted") {
                                                return (
                                                    <span className={"text-success font-weight-bold"}>{value}</span>
                                                );
                                            }

                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );

                                        case 'products_sum_price':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <ArchiveJobQuoteModal
                show={!!archiveJobQuoteModal}
                jobId={jobId}
                quoteId={!!archiveJobQuoteModal ? archiveJobQuoteModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveJobQuoteModal(null)}
                onComplete={(quote) => {
                    setArchiveJobQuoteModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Quote deleted.</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobQuoteDataTable;
